import React from 'react';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { About } from './components/About';
import { Agenda } from './components/Agenda';
import { WhyAttend } from './components/WhyAttend';
import { VenueHighlight } from './components/VenueHighlight';
import { Registration } from './components/Registration';
import { Sponsors } from './components/Sponsors';
import { Footer } from './components/Footer';
export function App() {
  return <div className="w-full min-h-screen bg-[#FFF8DC]" data-id="element-0" data-mp="2mlu9qp3etrta">
      <Header data-id="element-1" data-mp="2mn5f2tci77mi" />
      <main data-id="element-2" data-mp="2mnngs5hxqe1t">
        <Hero data-id="element-3" data-mp="2mjzm330r7lli" />
        <Sponsors data-id="element-4" data-mp="31aqhel1k12td" />
        <About data-id="element-5" data-mp="31b8fzobovt4g" />
        <WhyAttend data-id="element-6" data-mp="31brzvakwgrl4" />
        <Agenda data-id="element-7" data-mp="31c9y2cr4hfvo" />
        <VenueHighlight data-id="element-8" data-mp="31ctbbg5tvg3d" />
        <Registration data-id="element-9" data-mp="2wk9zanmsgt0o" />
      </main>
      <Footer data-id="element-10" data-mp="2wj8dpp85co4p" />
    </div>;
}